import { FC } from 'react'
import {
  SubscriptionSummaryCard,
  SubscriptionSummaryCardType,
} from './SummaryCard'
import { StatusTag, StatusTagType } from './StatusTag'
import { Banner, BannerType } from './Banner'
import { InvoicesCard, InvoicesCardType } from './InvoicesCard'

export const Subscription: FC &
  SubscriptionSummaryCardType &
  StatusTagType &
  BannerType &
  InvoicesCardType = (): JSX.Element => <></>

Subscription.SummaryCard = SubscriptionSummaryCard
Subscription.StatusTag = StatusTag
Subscription.Banner = Banner
Subscription.InvoicesCard = InvoicesCard
